import { render, staticRenderFns } from "./select-lens-thickness.vue?vue&type=template&id=5be88ee7&scoped=true"
import script from "./select-lens-thickness.vue?vue&type=script&lang=js"
export * from "./select-lens-thickness.vue?vue&type=script&lang=js"
import style0 from "./select-lens-thickness.vue?vue&type=style&index=0&id=5be88ee7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be88ee7",
  null
  
)

export default component.exports